exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap[data-v-7c25a830] {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.shim[data-v-7c25a830] {\n  display: block;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n}\n.img-pos[data-v-7c25a830] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  -webkit-transform-origin: 0 0;\n          transform-origin: 0 0;\n}\n.img-rotate[data-v-7c25a830] {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100%;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n}\n.img[data-v-7c25a830] {\n  left: 0;\n  top: 0;\n  position: relative;\n  width: 100%;\n  display: block;\n}", ""]);

// exports
